import { Check } from 'lucide-react';
import Navbar from './navigation/Navbar';
import Footer from './Footer';

const RegistrationDone = ({ registrationId }) => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen flex flex-col bg-transparent">
        <main className="flex-1 w-full flex items-center justify-center px-4 py-8 relative">
      <div className="absolute inset-0">
        <img
          src="/done.png"
          alt="Background"
          className="w-full h-full object-cover"
        />
       
      </div>

      <div className="relative z-10 bg-white rounded-2xl shadow-2xl p-8 sm:p-12 max-w-lg w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-[#2C774E] rounded-full p-3 flex items-center justify-center">
            <Check className="w-10 h-10 text-white font-bold" strokeWidth={2.5} />
          </div>
        </div>

        <h1 className="text-2xl sm:text-3xl font-extrabold text-[#2C774E] mb-3">
          Registration<br />Complete!
        </h1>

        <p className="text-[#2C774E] text-lg mb-2">
          Thank you for joining the EYES Ghana Program.
        </p>

        <p className="text-[#2C774E] text-lg mb-3">Your Unique ID is:</p>

        <div>
          <p className="text-xl sm:text-2xl font-extrabold text-[#2C774E] tracking-wide">
            {registrationId || 'N/A'}
          </p>
        </div>

        <p className="text-lg text-[#2C774E]">Keep this ID safe for the next steps.</p>
      </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default RegistrationDone;